import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function ChevronDown($$anchor, $$props) {
	const iconNode = [["path", { "d": "m6 9 6 6 6-6" }]];
	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiQ2hldnJvbkRvd24uc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCBJY29uIGZyb20gJy4vSWNvbi5zdmVsdGUnO1xuICBjb25zdCBpY29uTm9kZTogW3N0cmluZywgUmVjb3JkPHN0cmluZywgc3RyaW5nPl1bXSA9IFtbXCJwYXRoXCIsIHsgXCJkXCI6IFwibTYgOSA2IDYgNi02XCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOzt1REFEbEMsQ0FBQztPQUVPLFFBQTRDLEtBQUssTUFBTSxJQUFJLEdBQUcsRUFBRSxjQUFjO0tBQ2hGLElBQUk7Ozs7Ozs7O1FBRVcsSUFBSTs7QUFEMUIsQ0FBQyJ9